function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "637px",
    height: "193px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfbfc",
    d: "M -0.5,-0.5 C 211.833,-0.5 424.167,-0.5 636.5,-0.5C 636.5,63.8333 636.5,128.167 636.5,192.5C 424.167,192.5 211.833,192.5 -0.5,192.5C -0.5,128.167 -0.5,63.8333 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 24.5,4.5 C 220.5,4.33333 416.5,4.5 612.5,5C 622.035,7.8683 628.202,14.035 631,23.5C 631.982,73.8787 631.648,124.212 630,174.5C 626.563,182.938 620.396,188.105 611.5,190C 414.458,190.995 217.458,190.662 20.5,189C 12.8362,186.002 8.00288,180.502 6,172.5C 5.33333,122.167 5.33333,71.8333 6,21.5C 9.18981,12.4725 15.3565,6.80579 24.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#565656",
    d: "M 249.5,37.5 C 255.979,36.5093 262.646,36.176 269.5,36.5C 269.5,38.1667 269.5,39.8333 269.5,41.5C 266.833,41.5 264.167,41.5 261.5,41.5C 261.5,41.1667 261.5,40.8333 261.5,40.5C 263.833,40.5 266.167,40.5 268.5,40.5C 268.5,39.5 268.5,38.5 268.5,37.5C 262.167,37.5 255.833,37.5 249.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656565",
    d: "M 309.5,40.5 C 309.5,39.5 309.5,38.5 309.5,37.5C 303.5,37.5 297.5,37.5 291.5,37.5C 291.5,38.5 291.5,39.5 291.5,40.5C 290.566,39.4324 290.232,38.099 290.5,36.5C 297.167,36.5 303.833,36.5 310.5,36.5C 310.768,38.099 310.434,39.4324 309.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 246.5,37.5 C 246.5,38.5 246.5,39.5 246.5,40.5C 242.167,40.5 237.833,40.5 233.5,40.5C 233.5,43.5 233.5,46.5 233.5,49.5C 237.5,49.5 241.5,49.5 245.5,49.5C 245.5,50.5 245.5,51.5 245.5,52.5C 241.5,52.5 237.5,52.5 233.5,52.5C 233.5,55.5 233.5,58.5 233.5,61.5C 237.5,61.5 241.5,61.5 245.5,61.5C 245.5,62.5 245.5,63.5 245.5,64.5C 240.5,64.5 235.5,64.5 230.5,64.5C 230.5,55.5 230.5,46.5 230.5,37.5C 235.833,37.5 241.167,37.5 246.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfafb",
    d: "M 249.5,37.5 C 255.833,37.5 262.167,37.5 268.5,37.5C 268.5,38.5 268.5,39.5 268.5,40.5C 266.167,40.5 263.833,40.5 261.5,40.5C 260.833,48.3433 260.167,56.3433 259.5,64.5C 258.833,56.3433 258.167,48.3433 257.5,40.5C 254.833,40.5 252.167,40.5 249.5,40.5C 249.5,39.5 249.5,38.5 249.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b3b3",
    d: "M 283.5,37.5 C 283.5,46.5 283.5,55.5 283.5,64.5C 284.5,64.5 285.5,64.5 286.5,64.5C 285.432,65.4345 284.099,65.7678 282.5,65.5C 282.173,55.985 282.506,46.6517 283.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 283.5,37.5 C 284.5,37.5 285.5,37.5 286.5,37.5C 286.5,46.5 286.5,55.5 286.5,64.5C 285.5,64.5 284.5,64.5 283.5,64.5C 283.5,55.5 283.5,46.5 283.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 309.5,40.5 C 307.167,40.5 304.833,40.5 302.5,40.5C 301.833,48.3433 301.167,56.3433 300.5,64.5C 299.833,56.3433 299.167,48.3433 298.5,40.5C 296.167,40.5 293.833,40.5 291.5,40.5C 291.5,39.5 291.5,38.5 291.5,37.5C 297.5,37.5 303.5,37.5 309.5,37.5C 309.5,38.5 309.5,39.5 309.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9c9c9",
    d: "M 257.5,40.5 C 258.167,48.3433 258.833,56.3433 259.5,64.5C 260.167,56.3433 260.833,48.3433 261.5,40.5C 261.5,40.8333 261.5,41.1667 261.5,41.5C 261.5,49.5 261.5,57.5 261.5,65.5C 260.167,65.5 258.833,65.5 257.5,65.5C 257.5,57.1667 257.5,48.8333 257.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cacaca",
    d: "M 298.5,40.5 C 299.167,48.3433 299.833,56.3433 300.5,64.5C 301.167,56.3433 301.833,48.3433 302.5,40.5C 302.5,48.8333 302.5,57.1667 302.5,65.5C 301.167,65.5 299.833,65.5 298.5,65.5C 298.5,57.1667 298.5,48.8333 298.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#26c87e",
    d: "M 83.5,51.5 C 77.3878,48.6936 71.2211,46.0269 65,43.5C 64.6667,43.8333 64.3333,44.1667 64,44.5C 63.51,43.2068 63.3433,41.8734 63.5,40.5C 62.1667,40.5 60.8333,40.5 59.5,40.5C 60.6562,43.0788 61.6562,45.7455 62.5,48.5C 60.5,46.8333 58.5,45.1667 56.5,43.5C 55.4975,41.9891 54.8308,40.3224 54.5,38.5C 56.2884,37.3775 58.2884,37.2109 60.5,38C 68.3562,42.3956 76.0229,46.8956 83.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#545454",
    d: "M 211.5,50.5 C 215.97,49.5139 220.637,49.1805 225.5,49.5C 225.784,51.4147 225.451,53.0813 224.5,54.5C 224.5,53.1667 224.5,51.8333 224.5,50.5C 220.167,50.5 215.833,50.5 211.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f2f2",
    d: "M 370.5,54.5 C 371.504,55.6828 372.338,57.0161 373,58.5C 373.5,51.5079 373.666,44.5079 373.5,37.5C 374.5,37.5 375.5,37.5 376.5,37.5C 376.5,46.8333 376.5,56.1667 376.5,65.5C 375.022,65.762 373.689,65.4287 372.5,64.5C 368.489,57.8056 364.489,51.1389 360.5,44.5C 360.217,43.7109 359.717,43.0442 359,42.5C 358.5,49.8258 358.334,57.1591 358.5,64.5C 357.791,65.404 356.791,65.7373 355.5,65.5C 355.5,56.1667 355.5,46.8333 355.5,37.5C 357.467,37.2606 359.301,37.5939 361,38.5C 363.926,44.0261 367.093,49.3594 370.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#898989",
    d: "M 360.5,44.5 C 359.833,51.1667 359.167,57.8333 358.5,64.5C 358.334,57.1591 358.5,49.8258 359,42.5C 359.717,43.0442 360.217,43.7109 360.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#17e47d",
    d: "M 83.5,51.5 C 99.664,59.7451 115.331,68.7451 130.5,78.5C 130.5,79.1667 130.167,79.5 129.5,79.5C 126.709,78.2811 123.876,76.9478 121,75.5C 120.275,77.158 119.108,77.658 117.5,77C 118.876,74.4598 118.21,72.4598 115.5,71C 113.888,70.2797 112.388,70.4464 111,71.5C 110.228,70.1509 109.061,69.3176 107.5,69C 105.963,67.8904 105.297,66.3904 105.5,64.5C 102.016,63.2806 98.5158,61.9472 95,60.5C 92.3256,61.7859 90.4923,61.2859 89.5,59C 85.881,56.7587 83.0477,57.592 81,61.5C 80.6667,60.5 80.3333,59.5 80,58.5C 79.3333,60.5 79.3333,62.5 80,64.5C 81.5874,63.273 82.9207,63.6063 84,65.5C 84.6172,66.4491 84.4506,67.2825 83.5,68C 85.1412,69.129 86.1412,70.629 86.5,72.5C 77.6054,65.3603 69.6054,57.3603 62.5,48.5C 61.6562,45.7455 60.6562,43.0788 59.5,40.5C 60.8333,40.5 62.1667,40.5 63.5,40.5C 63.3433,41.8734 63.51,43.2068 64,44.5C 64.3333,44.1667 64.6667,43.8333 65,43.5C 71.2211,46.0269 77.3878,48.6936 83.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0dc8f9",
    d: "M 56.5,43.5 C 58.5,45.1667 60.5,46.8333 62.5,48.5C 69.6054,57.3603 77.6054,65.3603 86.5,72.5C 89.2911,75.5213 91.9578,78.5213 94.5,81.5C 96.1667,85.1667 98.8333,87.8333 102.5,89.5C 105.473,91.8062 108.14,94.4728 110.5,97.5C 110.5,97.8333 110.5,98.1667 110.5,98.5C 106.804,101.862 103.47,105.528 100.5,109.5C 98.9382,109.733 97.6049,110.4 96.5,111.5C 95.6868,108.327 94.3535,105.327 92.5,102.5C 89.37,100.268 86.0367,98.6016 82.5,97.5C 82.7989,95.396 82.4656,93.396 81.5,91.5C 76.9999,85.8943 71.9999,80.8943 66.5,76.5C 65.3112,75.5713 63.9778,75.238 62.5,75.5C 62.6567,74.1266 62.49,72.7932 62,71.5C 58.8398,69.7599 56.0065,67.7599 53.5,65.5C 52.9295,57.846 52.5962,50.1793 52.5,42.5C 53.9587,42.4326 55.2921,42.7659 56.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#414141",
    d: "M 373.5,37.5 C 373.666,44.5079 373.5,51.5079 373,58.5C 372.338,57.0161 371.504,55.6828 370.5,54.5C 372.146,49.0727 373.146,43.406 373.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 331.5,36.5 C 346.328,36.1535 352.162,43.1535 349,57.5C 344.841,64.6699 338.674,67.1699 330.5,65C 321.643,59.4287 319.476,51.9287 324,42.5C 326.114,39.8792 328.614,37.8792 331.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a0a0a",
    d: "M 331.5,40.5 C 344.111,39.7225 348.611,45.3891 345,57.5C 337.199,64.9217 330.866,63.9217 326,54.5C 324.349,48.3602 326.182,43.6936 331.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e9e9",
    d: "M 211.5,50.5 C 215.833,50.5 220.167,50.5 224.5,50.5C 224.5,51.8333 224.5,53.1667 224.5,54.5C 221.824,64.1789 215.49,67.6789 205.5,65C 196.643,59.4287 194.476,51.9287 199,42.5C 206.042,35.0989 213.542,34.5989 221.5,41C 220.667,41.8333 219.833,42.6667 219,43.5C 213.667,39.5 208.333,39.5 203,43.5C 197.698,56.8667 202.198,62.7 216.5,61C 219.397,59.2845 220.731,56.7845 220.5,53.5C 217.5,53.5 214.5,53.5 211.5,53.5C 211.5,52.5 211.5,51.5 211.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828282",
    d: "M 246.5,37.5 C 241.167,37.5 235.833,37.5 230.5,37.5C 230.5,46.5 230.5,55.5 230.5,64.5C 235.5,64.5 240.5,64.5 245.5,64.5C 245.5,63.5 245.5,62.5 245.5,61.5C 246.434,62.5676 246.768,63.901 246.5,65.5C 240.833,65.5 235.167,65.5 229.5,65.5C 229.5,55.8333 229.5,46.1667 229.5,36.5C 235.358,36.1778 241.025,36.5111 246.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0fed76",
    d: "M 129.5,79.5 C 125.443,83.2203 121.776,87.2203 118.5,91.5C 115.527,93.1468 112.86,95.1468 110.5,97.5C 108.14,94.4728 105.473,91.8062 102.5,89.5C 100.167,86.5 97.5,83.8333 94.5,81.5C 91.9578,78.5213 89.2911,75.5213 86.5,72.5C 86.1412,70.629 85.1412,69.129 83.5,68C 84.4506,67.2825 84.6172,66.4491 84,65.5C 82.9207,63.6063 81.5874,63.273 80,64.5C 79.3333,62.5 79.3333,60.5 80,58.5C 80.3333,59.5 80.6667,60.5 81,61.5C 83.0477,57.592 85.881,56.7587 89.5,59C 90.4923,61.2859 92.3256,61.7859 95,60.5C 98.5158,61.9472 102.016,63.2806 105.5,64.5C 105.297,66.3904 105.963,67.8904 107.5,69C 109.061,69.3176 110.228,70.1509 111,71.5C 112.388,70.4464 113.888,70.2797 115.5,71C 118.21,72.4598 118.876,74.4598 117.5,77C 119.108,77.658 120.275,77.158 121,75.5C 123.876,76.9478 126.709,78.2811 129.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#06d1d4",
    d: "M 94.5,81.5 C 97.5,83.8333 100.167,86.5 102.5,89.5C 98.8333,87.8333 96.1667,85.1667 94.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8cc0d",
    d: "M 130.5,78.5 C 139.098,82.4665 147.432,86.9665 155.5,92C 159.5,95.6667 159.5,99.3333 155.5,103C 147.944,107.456 140.277,111.622 132.5,115.5C 131.761,115.631 131.094,115.464 130.5,115C 131.357,114.311 132.023,113.478 132.5,112.5C 129.077,109.064 125.41,106.064 121.5,103.5C 121.808,102.692 122.308,102.025 123,101.5C 123.674,102.578 124.674,103.245 126,103.5C 128.059,102.382 130.226,101.715 132.5,101.5C 132.793,97.5633 132.46,93.73 131.5,90C 129.965,90.6609 128.298,90.9942 126.5,91C 127.388,89.2827 126.721,88.116 124.5,87.5C 122.235,88.4316 120.235,89.7649 118.5,91.5C 121.776,87.2203 125.443,83.2203 129.5,79.5C 130.167,79.5 130.5,79.1667 130.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f6f6",
    d: "M 245.5,122.5 C 246.404,121.791 246.737,120.791 246.5,119.5C 239.833,119.5 233.167,119.5 226.5,119.5C 226.5,116.833 226.5,114.167 226.5,111.5C 235.833,111.5 245.167,111.5 254.5,111.5C 256.405,129.881 248.405,141.048 230.5,145C 213.157,145.745 201.657,137.912 196,121.5C 193.721,102.234 201.888,89.7337 220.5,84C 228.276,82.8121 235.609,84.1454 242.5,88C 247.826,91.5726 247.493,94.7393 241.5,97.5C 232.446,91.5785 223.112,91.0785 213.5,96C 203.294,105.532 201.794,116.365 209,128.5C 220.022,138.804 231.356,139.138 243,129.5C 244.411,127.35 245.245,125.016 245.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#08d4fd",
    d: "M 53.5,65.5 C 56.0065,67.7599 58.8398,69.7599 62,71.5C 62.49,72.7932 62.6567,74.1266 62.5,75.5C 63.9778,75.238 65.3112,75.5713 66.5,76.5C 71.9999,80.8943 76.9999,85.8943 81.5,91.5C 82.4656,93.396 82.7989,95.396 82.5,97.5C 86.0367,98.6016 89.37,100.268 92.5,102.5C 94.3535,105.327 95.6868,108.327 96.5,111.5C 95.1667,113.167 93.8333,114.833 92.5,116.5C 92.5,117.167 92.1667,117.5 91.5,117.5C 89.8333,118.833 88.1667,120.167 86.5,121.5C 84.5,121.5 82.5,121.5 80.5,121.5C 80.67,120.178 80.3366,119.011 79.5,118C 76.5184,117.502 73.5184,117.335 70.5,117.5C 71.8196,112.093 69.8196,109.426 64.5,109.5C 64.0686,106.551 62.9019,103.884 61,101.5C 60.6667,96.5 60.3333,91.5 60,86.5C 58.3333,85.5 56.6667,84.5 55,83.5C 54.6667,85.1667 54.3333,86.8333 54,88.5C 52.2455,80.8509 52.0789,73.1843 53.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#535353",
    d: "M 480.5,86.5 C 472.5,86.5 464.5,86.5 456.5,86.5C 456.5,105.5 456.5,124.5 456.5,143.5C 455.503,124.341 455.17,105.007 455.5,85.5C 464.017,85.1739 472.35,85.5073 480.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 480.5,86.5 C 493.247,89.6528 498.08,97.6528 495,110.5C 492.043,117.233 486.876,120.899 479.5,121.5C 474.5,121.5 469.5,121.5 464.5,121.5C 464.5,128.833 464.5,136.167 464.5,143.5C 461.833,143.5 459.167,143.5 456.5,143.5C 456.5,124.5 456.5,105.5 456.5,86.5C 464.5,86.5 472.5,86.5 480.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 509.5,86.5 C 509.5,105.5 509.5,124.5 509.5,143.5C 506.833,143.5 504.167,143.5 501.5,143.5C 501.5,124.5 501.5,105.5 501.5,86.5C 504.167,86.5 506.833,86.5 509.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fac00b",
    d: "M 132.5,115.5 C 132.5,116.167 132.167,116.5 131.5,116.5C 124.5,110.5 117.5,104.5 110.5,98.5C 110.5,98.1667 110.5,97.8333 110.5,97.5C 112.86,95.1468 115.527,93.1468 118.5,91.5C 120.235,89.7649 122.235,88.4316 124.5,87.5C 126.721,88.116 127.388,89.2827 126.5,91C 128.298,90.9942 129.965,90.6609 131.5,90C 132.46,93.73 132.793,97.5633 132.5,101.5C 130.226,101.715 128.059,102.382 126,103.5C 124.674,103.245 123.674,102.578 123,101.5C 122.308,102.025 121.808,102.692 121.5,103.5C 125.41,106.064 129.077,109.064 132.5,112.5C 132.023,113.478 131.357,114.311 130.5,115C 131.094,115.464 131.761,115.631 132.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6b6b",
    d: "M 396.5,143.5 C 393.713,144.477 390.713,144.81 387.5,144.5C 387.5,124.833 387.5,105.167 387.5,85.5C 390.833,85.5 394.167,85.5 397.5,85.5C 397.83,105.007 397.497,124.341 396.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 396.5,143.5 C 393.833,143.5 391.167,143.5 388.5,143.5C 388.5,124.5 388.5,105.5 388.5,86.5C 391.167,86.5 393.833,86.5 396.5,86.5C 396.5,105.5 396.5,124.5 396.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030303",
    d: "M 478.5,94.5 C 487.415,96.9534 489.581,102.287 485,110.5C 484.097,111.701 482.931,112.535 481.5,113C 476.177,113.499 470.844,113.666 465.5,113.5C 465.5,107.167 465.5,100.833 465.5,94.5C 469.833,94.5 474.167,94.5 478.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a7a7a",
    d: "M 478.5,94.5 C 474.167,94.5 469.833,94.5 465.5,94.5C 465.5,100.833 465.5,107.167 465.5,113.5C 464.509,107.021 464.176,100.354 464.5,93.5C 469.363,93.1805 474.03,93.5139 478.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#15d9f7",
    d: "M 54.5,38.5 C 54.8308,40.3224 55.4975,41.9891 56.5,43.5C 55.2921,42.7659 53.9587,42.4326 52.5,42.5C 52.5962,50.1793 52.9295,57.846 53.5,65.5C 52.0789,73.1843 52.2455,80.8509 54,88.5C 54.3333,86.8333 54.6667,85.1667 55,83.5C 56.6667,84.5 58.3333,85.5 60,86.5C 60.3333,91.5 60.6667,96.5 61,101.5C 62.9019,103.884 64.0686,106.551 64.5,109.5C 69.8196,109.426 71.8196,112.093 70.5,117.5C 73.5184,117.335 76.5184,117.502 79.5,118C 80.3366,119.011 80.67,120.178 80.5,121.5C 82.5,121.5 84.5,121.5 86.5,121.5C 85.8333,122.833 85.1667,124.167 84.5,125.5C 80.1667,127.833 76.8333,131.167 74.5,135.5C 67.2224,141.109 60.5557,147.442 54.5,154.5C 53.5041,154.586 52.6708,154.252 52,153.5C 51.3333,116.167 51.3333,78.8333 52,41.5C 52.3768,40.0577 53.2101,39.0577 54.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f4",
    d: "M 525.5,105.5 C 535.872,103.611 543.372,107.278 548,116.5C 548.5,125.494 548.666,134.494 548.5,143.5C 545.5,143.5 542.5,143.5 539.5,143.5C 539.649,142.448 539.483,141.448 539,140.5C 537.681,142.487 535.848,143.654 533.5,144C 518.617,146.121 512.784,139.955 516,125.5C 519.791,121.068 524.624,119.068 530.5,119.5C 533.533,119.669 536.533,120.002 539.5,120.5C 539.201,117.358 537.534,115.191 534.5,114C 529.676,112.594 525.676,113.76 522.5,117.5C 514.094,115.869 513.428,112.702 520.5,108C 522.315,107.243 523.981,106.41 525.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f4",
    d: "M 272.5,105.5 C 293.212,105.702 300.712,115.702 295,135.5C 284.03,148.258 272.697,148.591 261,136.5C 254.337,122.104 258.17,111.771 272.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f6f6",
    d: "M 315.5,105.5 C 333.041,104.873 341.208,113.206 340,130.5C 338.264,137.237 334.097,141.737 327.5,144C 308.386,146.22 299.886,137.72 302,118.5C 305.101,112.563 309.601,108.23 315.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f5f6",
    d: "M 373.5,109.5 C 374.42,110.067 374.754,109.401 374.5,107.5C 376.833,107.5 379.167,107.5 381.5,107.5C 381.5,120.833 381.5,134.167 381.5,147.5C 378.508,160.177 370.508,165.01 357.5,162C 352.221,160.385 348.554,157.052 346.5,152C 347.778,149.829 349.778,148.662 352.5,148.5C 354.624,150.121 356.624,151.954 358.5,154C 368.948,156.214 373.782,152.047 373,141.5C 360.137,148.069 350.803,144.736 345,131.5C 342.624,117.242 348.457,108.575 362.5,105.5C 366.646,105.658 370.312,106.992 373.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3f3",
    d: "M 414.5,105.5 C 425.969,104.494 433.636,109.327 437.5,120C 428.782,123.738 420.115,127.572 411.5,131.5C 414.25,136.623 418.417,138.29 424,136.5C 426.591,135.566 428.924,134.233 431,132.5C 432.963,133.625 434.796,134.959 436.5,136.5C 425.718,148.441 414.884,148.441 404,136.5C 397.437,122.687 400.937,112.353 414.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f4",
    d: "M 549.5,106.5 C 552.572,106.183 555.572,106.516 558.5,107.5C 561.911,115.576 565.411,123.576 569,131.5C 571.89,123.388 575.056,115.388 578.5,107.5C 581.784,106.343 585.118,106.176 588.5,107C 580.5,125 572.5,143 564.5,161C 561.5,161.667 558.5,161.667 555.5,161C 558.629,154.575 561.629,148.075 564.5,141.5C 558.918,130.09 553.918,118.423 549.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f33747",
    d: "M 110.5,98.5 C 117.5,104.5 124.5,110.5 131.5,116.5C 127.762,117.88 124.429,120.047 121.5,123C 119.235,124.118 116.901,124.951 114.5,125.5C 108.851,126.505 104.018,127.838 100,129.5C 94.9121,126.581 93.4121,128.081 95.5,134C 93.1667,134.333 90.8333,134.667 88.5,135C 89.9733,135.71 90.6399,136.876 90.5,138.5C 86.0749,139.243 83.4082,137.41 82.5,133C 85.2152,127.6 88.2152,122.434 91.5,117.5C 92.1667,117.5 92.5,117.167 92.5,116.5C 95.7642,114.906 98.4309,112.573 100.5,109.5C 103.47,105.528 106.804,101.862 110.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8a8a8",
    d: "M 509.5,86.5 C 506.833,86.5 504.167,86.5 501.5,86.5C 501.5,105.5 501.5,124.5 501.5,143.5C 500.503,124.341 500.17,105.007 500.5,85.5C 503.713,85.19 506.713,85.5233 509.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b35b66",
    d: "M 100.5,109.5 C 98.4309,112.573 95.7642,114.906 92.5,116.5C 93.8333,114.833 95.1667,113.167 96.5,111.5C 97.6049,110.4 98.9382,109.733 100.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#080808",
    d: "M 273.5,113.5 C 287.538,113.9 291.704,120.567 286,133.5C 278.133,139.726 271.8,138.393 267,129.5C 265.607,122.631 267.774,117.297 273.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070707",
    d: "M 360.5,113.5 C 368.913,112.745 373.58,116.578 374.5,125C 374.473,132.693 370.64,136.859 363,137.5C 353.955,134.064 351.288,127.731 355,118.5C 356.73,116.598 358.563,114.931 360.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#101010",
    d: "M 416.5,113.5 C 419.93,113.107 423.096,113.773 426,115.5C 426.667,116.167 426.667,116.833 426,117.5C 420.893,119.926 415.726,122.26 410.5,124.5C 409.337,122.45 409.504,120.45 411,118.5C 412.73,116.598 414.563,114.931 416.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#090909",
    d: "M 316.5,113.5 C 329.699,113.543 334.199,119.876 330,132.5C 322.083,139.917 315.416,138.917 310,129.5C 308.607,122.631 310.774,117.297 316.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9a9a",
    d: "M 381.5,147.5 C 381.5,134.167 381.5,120.833 381.5,107.5C 379.167,107.5 376.833,107.5 374.5,107.5C 374.754,109.401 374.42,110.067 373.5,109.5C 373.5,108.5 373.5,107.5 373.5,106.5C 376.5,106.5 379.5,106.5 382.5,106.5C 382.829,120.344 382.496,134.01 381.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#818181",
    d: "M 226.5,119.5 C 233.167,119.5 239.833,119.5 246.5,119.5C 246.737,120.791 246.404,121.791 245.5,122.5C 239.399,120.851 233.065,119.851 226.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747474",
    d: "M 479.5,121.5 C 475.03,122.486 470.363,122.819 465.5,122.5C 465.5,129.833 465.5,137.167 465.5,144.5C 462.287,144.81 459.287,144.477 456.5,143.5C 459.167,143.5 461.833,143.5 464.5,143.5C 464.5,136.167 464.5,128.833 464.5,121.5C 469.5,121.5 474.5,121.5 479.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c0c0c",
    d: "M 527.5,126.5 C 531.548,126.395 535.548,126.728 539.5,127.5C 539.166,133.998 535.666,137.331 529,137.5C 524.406,136.751 522.739,134.085 524,129.5C 525.145,128.364 526.312,127.364 527.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac526e",
    d: "M 84.5,125.5 C 81.5,129.167 78.1667,132.5 74.5,135.5C 76.8333,131.167 80.1667,127.833 84.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e13050",
    d: "M 91.5,117.5 C 88.2152,122.434 85.2152,127.6 82.5,133C 83.4082,137.41 86.0749,139.243 90.5,138.5C 90.6399,136.876 89.9733,135.71 88.5,135C 90.8333,134.667 93.1667,134.333 95.5,134C 93.4121,128.081 94.9121,126.581 100,129.5C 104.018,127.838 108.851,126.505 114.5,125.5C 96.9142,136.581 78.9142,146.915 60.5,156.5C 58.712,156.785 57.0453,156.452 55.5,155.5C 61.8549,148.813 68.1882,142.146 74.5,135.5C 78.1667,132.5 81.5,129.167 84.5,125.5C 85.1667,124.167 85.8333,122.833 86.5,121.5C 88.1667,120.167 89.8333,118.833 91.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#974264",
    d: "M 74.5,135.5 C 68.1882,142.146 61.8549,148.813 55.5,155.5C 57.0453,156.452 58.712,156.785 60.5,156.5C 58.7354,157.461 56.7354,157.795 54.5,157.5C 54.5,156.5 54.5,155.5 54.5,154.5C 60.5557,147.442 67.2224,141.109 74.5,135.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.ed41dfb42876d8d9f56c339757f90d2f.svg";
export { ForwardRef as ReactComponent };